// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + ".twh." + {"FavouritesUiDynamicBuyerInfoModal":"72c28b65","SmartBannerFullScreen":"7a8d3bed"}[chunkId] + ".css";
};